import {
    SchoolSettingsAction,
    SAVE_SCHOOL_OFFER_SETTINGS,
    SAVE_SCHOOL_COLOR_SETTINGS,
    SAVE_SCHOOL_CALENDAR_SETTINGS
} from '../actions/SchoolSettingsActions';
import { StoreState, SchoolOfferSettings, SchoolColorSettings, SchoolCalendarSettings } from '../types';
import { Epic, combineEpics } from 'redux-observable';
import * as api from '../api';
import { createTryActionsEpic } from './Common';

const saveOfferSettings = async ({ schoolId, settings }: { schoolId: string, settings: SchoolOfferSettings }, { auth }: StoreState) => {
    const user = auth.user;
    if (!user || !user.uid) {
        throw new Error('Tried to save offer settings without authenticating');
    }

    if (!schoolId) {
        throw new Error('Invalid schoolId');
    }

    if (!settings) {
        throw new Error('Invalid settings');
    }

    return await api.saveOfferSettings({
        schoolId: schoolId,
        currency: settings.currency || '',
        depositMin: settings.depositMin || 0,
        depositMax: settings.depositMax || 0,
        includedItems: settings.includedItems || {},
        instantBooking: settings.instantBooking || { enabled: false, options: {} }
    });
};

const saveColorSettings = async ({ schoolId, settings }: { schoolId: string, settings: SchoolColorSettings }, { auth }: StoreState) => {
    const user = auth.user;
    if (!user || !user.uid) {
        throw new Error('Tried to save color settings without authenticating');
    }

    if (!schoolId) {
        throw new Error('Invalid schoolId');
    }

    if (!settings) {
        throw new Error('Invalid settings');
    }

    return await api.saveColorSettings({
        schoolId: schoolId,
        bookingStatus: settings.bookingStatus || {}
    });
};

const saveCalendarSettings = async ({ schoolId, settings }: { schoolId: string, settings: SchoolCalendarSettings }, { auth }: StoreState) => {
    const user = auth.user;
    if (!user || !user.uid) {
        throw new Error('Tried to save calendar settings without authenticating');
    }

    if (!schoolId) {
        throw new Error('Invalid schoolId');
    }

    if (!settings) {
        throw new Error('Invalid settings');
    }

    return await api.saveCalendarSettings({
        schoolId: schoolId,
        accessToken: settings.accessToken || ''
    });
};

const saveOfferSettingsEpic: Epic<SchoolSettingsAction, SchoolSettingsAction, StoreState> =
    createTryActionsEpic(
        SAVE_SCHOOL_OFFER_SETTINGS,
        (a, s) => saveOfferSettings(a.value, s),
        (a, r) => a.value);

const saveColorSettingsEpic: Epic<SchoolSettingsAction, SchoolSettingsAction, StoreState> =
    createTryActionsEpic(
        SAVE_SCHOOL_COLOR_SETTINGS,
        (a, s) => saveColorSettings(a.value, s),
        (a, r) => a.value);

const saveCalendarSettingsEpic: Epic<SchoolSettingsAction, SchoolSettingsAction, StoreState> =
    createTryActionsEpic(
        SAVE_SCHOOL_CALENDAR_SETTINGS,
        (a, s) => saveCalendarSettings(a.value, s),
        (a, r) => a.value);

export default combineEpics<SchoolSettingsAction, SchoolSettingsAction, StoreState>(
    saveOfferSettingsEpic,
    saveColorSettingsEpic,
    saveCalendarSettingsEpic
);
